"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _default2 = exports.default = {
  name: 'poa',
  props: {
    poaData: {
      type: Object,
      default: function _default() {}
    },
    type: {
      type: String,
      default: 'poa'
    }
  },
  watch: {
    poaData: function poaData(val) {
      var output = Object.entries(val).filter(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
          key = _ref2[0];
        return key !== "img";
      }).map(function (_ref3) {
        var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          name = _ref4[0],
          data = _ref4[1];
        var keys = Object.keys(data);
        return {
          name: name,
          img: val.img,
          // 添加 img 信息
          leftNum: "".concat(data[keys[2]][1]),
          leftText: keys[2],
          rightTopNum: "".concat(data[keys[0]][1]).concat(data[keys[0]][0]),
          rightTopText: keys[0],
          rightBottomNum: "".concat(data[keys[1]][1]).concat(data[keys[1]][0]),
          rightBottomText: keys[1]
        };
      });
      this.deviceEntries = output[0];
    }
  },
  data: function data() {
    return {
      deviceEntries: {}
    };
  },
  methods: {}
};